function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useContext } from "react";
import Select from "react-select";
import { StyledVibeBanner } from "./banner-component.scss";
import colors from "styles/colors";
import { getAddonPricePerUnit } from "../../use-addon";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { getCurrencyName, getCurrencyWithPriceDisplay } from "/services/pricing-service";
import { ADDON_CONFIG, ADDONS } from "constants/addons";
import { PERIODS } from "constants/pricing";
const selectStyles = {
    option: (provided, state)=>_object_spread_props(_object_spread({}, provided), {
            color: state.isSelected ? colors["dodger-blue"] : "#333333",
            backgroundColor: state.isSelected ? "#dff0ff" : state.isFocused ? "#ebf5ff" : colors.white,
            fontSize: "0.875rem",
            cursor: "pointer"
        }),
    menuPortal: (provided)=>_object_spread_props(_object_spread({}, provided), {
            zIndex: 9999
        })
};
const VibeBanner = ({ addon, selectedUnit, onUnitChange, period = PERIODS.yearly })=>{
    const { translate, currency: currencyFromContext, localeId, forceCurrency, cloudfrontViewerCountry } = useContext(GenericConfigContext);
    const currency = currencyFromContext || getCurrencyName({
        forceCurrency,
        countryCode: cloudfrontViewerCountry
    });
    const vibeConfig = ADDON_CONFIG[ADDONS.VIBE];
    const publishedAppsOptions = useMemo(()=>{
        return vibeConfig.unitOptions.map((option)=>({
                label: translate(option.labelKey),
                value: option.value
            }));
    }, [
        translate,
        vibeConfig.unitOptions
    ]);
    const selectedOption = useMemo(()=>{
        return publishedAppsOptions.find((option)=>option.value === selectedUnit) || publishedAppsOptions[0];
    }, [
        selectedUnit,
        publishedAppsOptions
    ]);
    const handleAppsChange = useCallback((option)=>{
        onUnitChange(option.value);
    }, [
        onUnitChange
    ]);
    const pricePerUnit = getAddonPricePerUnit(addon, currency, period);
    const addonTotalPrice = pricePerUnit ? selectedUnit * pricePerUnit : 0;
    const priceDisplay = useMemo(()=>{
        return getCurrencyWithPriceDisplay({
            price: addonTotalPrice.toLocaleString(),
            currency,
            localeId,
            hideCurrency: false
        });
    }, [
        addonTotalPrice,
        currency,
        localeId
    ]);
    if (!addon) {
        return null;
    }
    return /*#__PURE__*/ _jsx(StyledVibeBanner, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "vibe-banner-content",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "vibe-banner-left-content",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "vibe-banner-text",
                            children: translate(vibeConfig.bannerTextKey)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "vibe-banner-dropdown",
                            children: /*#__PURE__*/ _jsx(Select, {
                                className: "published-apps-select",
                                classNamePrefix: "select",
                                isClearable: false,
                                isSearchable: false,
                                value: selectedOption,
                                onChange: handleAppsChange,
                                options: publishedAppsOptions,
                                styles: selectStyles,
                                menuPortalTarget: typeof document !== "undefined" ? document.body : null
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "vibe-banner-right-content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "vibe-price",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "price-amount",
                                children: priceDisplay
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "price-period",
                                children: [
                                    " ",
                                    translate("pricingPage.perMonthSlash")
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default VibeBanner;
